export const UserActivitiesActionTypes = {
  GET_NUM_LOGINS: "GET_NUM_LOGINS",
  GET_NUM_LOGINS_PENDING: "GET_NUM_LOGINS_PENDING",
  GET_NUM_LOGINS_FULFILLED: "GET_NUM_LOGINS_FULFILLED",

  CLEAR_NUM_LOGINS: "CLEAR_NUM_LOGINS",
}